import { ActionTree } from "vuex";
import { ISlotState } from "./state";
import { ISlot } from "@/models";
import { AxiosResponse } from "axios";
import { apiClient } from "@/services";
import { SET_SLOTS } from "./mutations-types";

export const actions: ActionTree<ISlotState, number> = {
    async fetchSlots(context): Promise<AxiosResponse<ISlot[]>> {
        const response = await apiClient.get<ISlot[]>("/slots");
        context.commit(SET_SLOTS, response.data);

        return response;
    },
};
